var map = {
	"./animals/i_birds-1.svg": [
		33355,
		87
	],
	"./animals/i_birds-10.svg": [
		44369,
		87
	],
	"./animals/i_birds-11.svg": [
		81568,
		87
	],
	"./animals/i_birds-12.svg": [
		52467,
		87
	],
	"./animals/i_birds-13.svg": [
		73474,
		87
	],
	"./animals/i_birds-14.svg": [
		48141,
		87
	],
	"./animals/i_birds-2.svg": [
		94520,
		87
	],
	"./animals/i_birds-3.svg": [
		70025,
		87
	],
	"./animals/i_birds-4.svg": [
		26790,
		87
	],
	"./animals/i_birds-5.svg": [
		89591,
		87
	],
	"./animals/i_birds-6.svg": [
		84996,
		87
	],
	"./animals/i_birds-7.svg": [
		63013,
		87
	],
	"./animals/i_birds-8.svg": [
		60898,
		87
	],
	"./animals/i_birds-9.svg": [
		75123,
		87
	],
	"./animals/i_land-1.svg": [
		53330,
		87
	],
	"./animals/i_land-10.svg": [
		54478,
		87
	],
	"./animals/i_land-11.svg": [
		92415,
		87
	],
	"./animals/i_land-12.svg": [
		29740,
		87
	],
	"./animals/i_land-13.svg": [
		65197,
		87
	],
	"./animals/i_land-14.svg": [
		55906,
		87
	],
	"./animals/i_land-15.svg": [
		70131,
		87
	],
	"./animals/i_land-16.svg": [
		79392,
		87
	],
	"./animals/i_land-17.svg": [
		36305,
		87
	],
	"./animals/i_land-18.svg": [
		38150,
		87
	],
	"./animals/i_land-19.svg": [
		84599,
		87
	],
	"./animals/i_land-2.svg": [
		46465,
		87
	],
	"./animals/i_land-20.svg": [
		17219,
		87
	],
	"./animals/i_land-21.svg": [
		84178,
		87
	],
	"./animals/i_land-22.svg": [
		65921,
		87
	],
	"./animals/i_land-23.svg": [
		51120,
		87
	],
	"./animals/i_land-24.svg": [
		68591,
		87
	],
	"./animals/i_land-25.svg": [
		6014,
		87
	],
	"./animals/i_land-26.svg": [
		18109,
		87
	],
	"./animals/i_land-27.svg": [
		89564,
		87
	],
	"./animals/i_land-28.svg": [
		91803,
		87
	],
	"./animals/i_land-29.svg": [
		49834,
		87
	],
	"./animals/i_land-3.svg": [
		10928,
		87
	],
	"./animals/i_land-30.svg": [
		98432,
		87
	],
	"./animals/i_land-31.svg": [
		34385,
		87
	],
	"./animals/i_land-32.svg": [
		14018,
		87
	],
	"./animals/i_land-33.svg": [
		19187,
		87
	],
	"./animals/i_land-34.svg": [
		85292,
		87
	],
	"./animals/i_land-35.svg": [
		84237,
		87
	],
	"./animals/i_land-36.svg": [
		35886,
		87
	],
	"./animals/i_land-37.svg": [
		64319,
		87
	],
	"./animals/i_land-38.svg": [
		61432,
		87
	],
	"./animals/i_land-39.svg": [
		65673,
		87
	],
	"./animals/i_land-4.svg": [
		76815,
		87
	],
	"./animals/i_land-40.svg": [
		74573,
		87
	],
	"./animals/i_land-41.svg": [
		75628,
		87
	],
	"./animals/i_land-42.svg": [
		54655,
		87
	],
	"./animals/i_land-43.svg": [
		26222,
		87
	],
	"./animals/i_land-44.svg": [
		24721,
		87
	],
	"./animals/i_land-45.svg": [
		88768,
		87
	],
	"./animals/i_land-46.svg": [
		9523,
		87
	],
	"./animals/i_land-47.svg": [
		4354,
		87
	],
	"./animals/i_land-5.svg": [
		33086,
		87
	],
	"./animals/i_land-6.svg": [
		87261,
		87
	],
	"./animals/i_land-7.svg": [
		97788,
		87
	],
	"./animals/i_land-8.svg": [
		60955,
		87
	],
	"./animals/i_land-9.svg": [
		586,
		87
	],
	"./animals/i_sea-1.svg": [
		38434,
		87
	],
	"./animals/i_sea-2.svg": [
		92977,
		87
	],
	"./animals/i_sea-3.svg": [
		30176,
		87
	],
	"./animals/i_sea-4.svg": [
		88735,
		87
	],
	"./animals/i_sea-5.svg": [
		67630,
		87
	],
	"./animals/i_sea-6.svg": [
		96749,
		87
	],
	"./animals/i_sea-7.svg": [
		17036,
		87
	],
	"./animals/i_sea-8.svg": [
		24683,
		87
	],
	"./animals/i_sea-9.svg": [
		5626,
		87
	],
	"./basic/icon-arch.svg": [
		65800,
		87
	],
	"./basic/icon-arrow1.svg": [
		6008,
		87
	],
	"./basic/icon-arrow2.svg": [
		44843,
		87
	],
	"./basic/icon-arrow3.svg": [
		39578,
		87
	],
	"./basic/icon-capsule.svg": [
		72157,
		87
	],
	"./basic/icon-check.svg": [
		57560,
		87
	],
	"./basic/icon-chevron.svg": [
		53265,
		87
	],
	"./basic/icon-circle.svg": [
		98308,
		87
	],
	"./basic/icon-cloud.svg": [
		81675,
		87
	],
	"./basic/icon-crescent1.svg": [
		43854,
		87
	],
	"./basic/icon-crescent2.svg": [
		92205,
		87
	],
	"./basic/icon-diamond.svg": [
		39948,
		87
	],
	"./basic/icon-divide.svg": [
		91795,
		87
	],
	"./basic/icon-doubleArrow.svg": [
		65194,
		87
	],
	"./basic/icon-drop.svg": [
		66343,
		87
	],
	"./basic/icon-equal.svg": [
		48888,
		87
	],
	"./basic/icon-heart1.svg": [
		72581,
		87
	],
	"./basic/icon-heart2.svg": [
		40806,
		87
	],
	"./basic/icon-heart3.svg": [
		46135,
		87
	],
	"./basic/icon-heart4.svg": [
		1208,
		87
	],
	"./basic/icon-hexagon.svg": [
		78532,
		87
	],
	"./basic/icon-label1.svg": [
		67639,
		87
	],
	"./basic/icon-label2.svg": [
		24516,
		87
	],
	"./basic/icon-label3.svg": [
		75685,
		87
	],
	"./basic/icon-lightning.svg": [
		84574,
		87
	],
	"./basic/icon-minus.svg": [
		76648,
		87
	],
	"./basic/icon-multiply.svg": [
		1904,
		87
	],
	"./basic/icon-navigator.svg": [
		70467,
		87
	],
	"./basic/icon-octagon.svg": [
		38009,
		87
	],
	"./basic/icon-parallelogram.svg": [
		17137,
		87
	],
	"./basic/icon-pentagon.svg": [
		38844,
		87
	],
	"./basic/icon-plus.svg": [
		96384,
		87
	],
	"./basic/icon-quadrant.svg": [
		20795,
		87
	],
	"./basic/icon-ribbon1.svg": [
		63241,
		87
	],
	"./basic/icon-ribbon2.svg": [
		78778,
		87
	],
	"./basic/icon-ring.svg": [
		44630,
		87
	],
	"./basic/icon-scallopCircle1.svg": [
		84139,
		87
	],
	"./basic/icon-scallopCircle2.svg": [
		49752,
		87
	],
	"./basic/icon-sector.svg": [
		2686,
		87
	],
	"./basic/icon-semicircle.svg": [
		7709,
		87
	],
	"./basic/icon-sparkle.svg": [
		55678,
		87
	],
	"./basic/icon-square1.svg": [
		14086,
		87
	],
	"./basic/icon-square2.svg": [
		36517,
		87
	],
	"./basic/icon-star1.svg": [
		46081,
		87
	],
	"./basic/icon-star2.svg": [
		57394,
		87
	],
	"./basic/icon-star3.svg": [
		95331,
		87
	],
	"./basic/icon-star4.svg": [
		20700,
		87
	],
	"./basic/icon-sun.svg": [
		35594,
		87
	],
	"./basic/icon-tablet.svg": [
		43728,
		87
	],
	"./basic/icon-ticket.svg": [
		46580,
		87
	],
	"./basic/icon-trapezoid.svg": [
		74976,
		87
	],
	"./basic/icon-triangle.svg": [
		68244,
		87
	],
	"./basic/icon-wave.svg": [
		98619,
		87
	],
	"./decor/i_circular-1.svg": [
		39714,
		87
	],
	"./decor/i_circular-10.svg": [
		71166,
		87
	],
	"./decor/i_circular-11.svg": [
		14895,
		87
	],
	"./decor/i_circular-12.svg": [
		35868,
		87
	],
	"./decor/i_circular-2.svg": [
		60081,
		87
	],
	"./decor/i_circular-3.svg": [
		40480,
		87
	],
	"./decor/i_circular-4.svg": [
		90015,
		87
	],
	"./decor/i_circular-5.svg": [
		77934,
		87
	],
	"./decor/i_circular-6.svg": [
		9933,
		87
	],
	"./decor/i_circular-7.svg": [
		27340,
		87
	],
	"./decor/i_circular-8.svg": [
		37867,
		87
	],
	"./decor/i_circular-9.svg": [
		23258,
		87
	],
	"./decor/i_corner-1.svg": [
		3930,
		87
	],
	"./decor/i_corner-10.svg": [
		15078,
		87
	],
	"./decor/i_corner-2.svg": [
		19017,
		87
	],
	"./decor/i_corner-3.svg": [
		84152,
		87
	],
	"./decor/i_corner-4.svg": [
		87607,
		87
	],
	"./decor/i_corner-5.svg": [
		16422,
		87
	],
	"./decor/i_corner-6.svg": [
		15557,
		87
	],
	"./decor/i_corner-7.svg": [
		60836,
		87
	],
	"./decor/i_corner-8.svg": [
		99379,
		87
	],
	"./decor/i_corner-9.svg": [
		20386,
		87
	],
	"./decor/i_line-1a.svg": [
		75496,
		87
	],
	"./decor/i_line-1b.svg": [
		56859,
		87
	],
	"./decor/i_line-2a.svg": [
		47025,
		87
	],
	"./decor/i_line-2b.svg": [
		26658,
		87
	],
	"./decor/i_line-3.svg": [
		79089,
		87
	],
	"./decor/i_line-4.svg": [
		67534,
		87
	],
	"./decor/i_line-5.svg": [
		4556,
		87
	],
	"./decor/i_line-6.svg": [
		3148,
		87
	],
	"./decor/i_photo-1a.svg": [
		71484,
		87
	],
	"./decor/i_photo-1b.svg": [
		50511,
		87
	],
	"./decor/i_photo-2a.svg": [
		7157,
		87
	],
	"./decor/i_photo-2b.svg": [
		70518,
		87
	],
	"./decor/i_photo-3a.svg": [
		13318,
		87
	],
	"./decor/i_photo-3b.svg": [
		35749,
		87
	],
	"./decor/i_photo-4a.svg": [
		53263,
		87
	],
	"./decor/i_photo-4b.svg": [
		74236,
		87
	],
	"./decor/i_ribbon-1a.svg": [
		44122,
		87
	],
	"./decor/i_ribbon-1b.svg": [
		42857,
		87
	],
	"./decor/i_ribbon-2a.svg": [
		27527,
		87
	],
	"./decor/i_ribbon-2b.svg": [
		56020,
		87
	],
	"./decor/i_ribbon-3a.svg": [
		69168,
		87
	],
	"./decor/i_ribbon-3b.svg": [
		58563,
		87
	],
	"./decor/i_ribbon-4a.svg": [
		77325,
		87
	],
	"./decor/i_ribbon-4b.svg": [
		28974,
		87
	],
	"./decor/i_ribbon-5a.svg": [
		19646,
		87
	],
	"./decor/i_ribbon-5b.svg": [
		73821,
		87
	],
	"./decor/i_ribbon-6a.svg": [
		95051,
		87
	],
	"./decor/i_ribbon-6b.svg": [
		56216,
		87
	],
	"./decor/i_ribbon-7a.svg": [
		22036,
		87
	],
	"./decor/i_ribbon-7b.svg": [
		93543,
		87
	],
	"./decor/i_ribbon-8a.svg": [
		5969,
		87
	],
	"./decor/i_ribbon-8b.svg": [
		41922,
		87
	],
	"./decor/i_speech-1a.svg": [
		29856,
		87
	],
	"./decor/i_speech-1b.svg": [
		50611,
		87
	],
	"./decor/i_speech-2a.svg": [
		81193,
		87
	],
	"./decor/i_speech-2b.svg": [
		66106,
		87
	],
	"./decor/i_speech-3a.svg": [
		93226,
		87
	],
	"./decor/i_speech-3b.svg": [
		53977,
		87
	],
	"./decor/i_speech-4a.svg": [
		75643,
		87
	],
	"./decor/i_speech-4b.svg": [
		94280,
		87
	],
	"./decor/i_speech-5a.svg": [
		13348,
		87
	],
	"./decor/i_speech-5b.svg": [
		56471,
		87
	],
	"./decor/i_speech-6a.svg": [
		95805,
		87
	],
	"./decor/i_speech-6b.svg": [
		57982,
		87
	],
	"./decor/i_speech-7a.svg": [
		43150,
		87
	],
	"./decor/i_speech-7b.svg": [
		53869,
		87
	],
	"./decor/i_speech-8a.svg": [
		48495,
		87
	],
	"./decor/i_speech-8b.svg": [
		69468,
		87
	],
	"./decor/i_text-10a.svg": [
		87765,
		87
	],
	"./decor/i_text-10b.svg": [
		74806,
		87
	],
	"./decor/i_text-11a.svg": [
		51398,
		87
	],
	"./decor/i_text-11b.svg": [
		50533,
		87
	],
	"./decor/i_text-12a.svg": [
		53619,
		87
	],
	"./decor/i_text-12b.svg": [
		8960,
		87
	],
	"./decor/i_text-13a.svg": [
		71772,
		87
	],
	"./decor/i_text-13b.svg": [
		74095,
		87
	],
	"./decor/i_text-14a.svg": [
		87118,
		87
	],
	"./decor/i_text-14b.svg": [
		76050,
		87
	],
	"./decor/i_text-15a.svg": [
		27906,
		87
	],
	"./decor/i_text-15b.svg": [
		48273,
		87
	],
	"./decor/i_text-1a.svg": [
		28141,
		87
	],
	"./decor/i_text-1b.svg": [
		28814,
		87
	],
	"./decor/i_text-2a.svg": [
		65908,
		87
	],
	"./decor/i_text-2b.svg": [
		14119,
		87
	],
	"./decor/i_text-3a.svg": [
		49771,
		87
	],
	"./decor/i_text-3b.svg": [
		99032,
		87
	],
	"./decor/i_text-4a.svg": [
		43962,
		87
	],
	"./decor/i_text-4b.svg": [
		69545,
		87
	],
	"./decor/i_text-5a.svg": [
		16345,
		87
	],
	"./decor/i_text-5b.svg": [
		24970,
		87
	],
	"./decor/i_text-6a.svg": [
		47888,
		87
	],
	"./decor/i_text-6b.svg": [
		93027,
		87
	],
	"./decor/i_text-7a.svg": [
		47719,
		87
	],
	"./decor/i_text-7b.svg": [
		59860,
		87
	],
	"./decor/i_text-8a.svg": [
		94582,
		87
	],
	"./decor/i_text-8b.svg": [
		35829,
		87
	],
	"./decor/i_text-9a.svg": [
		15954,
		87
	],
	"./decor/i_text-9b.svg": [
		94438,
		87
	],
	"./holidays/i_CNY-10.svg": [
		72247,
		87
	],
	"./holidays/i_CNY-1a.svg": [
		23830,
		87
	],
	"./holidays/i_CNY-1b.svg": [
		44117,
		87
	],
	"./holidays/i_CNY-2a.svg": [
		27907,
		87
	],
	"./holidays/i_CNY-2b.svg": [
		87216,
		87
	],
	"./holidays/i_CNY-3.svg": [
		4223,
		87
	],
	"./holidays/i_CNY-4.svg": [
		38336,
		87
	],
	"./holidays/i_CNY-5a.svg": [
		29074,
		87
	],
	"./holidays/i_CNY-5b.svg": [
		10817,
		87
	],
	"./holidays/i_CNY-6a.svg": [
		607,
		87
	],
	"./holidays/i_CNY-6b.svg": [
		28908,
		87
	],
	"./holidays/i_CNY-7a.svg": [
		97448,
		87
	],
	"./holidays/i_CNY-7b.svg": [
		78811,
		87
	],
	"./holidays/i_CNY-8a.svg": [
		57389,
		87
	],
	"./holidays/i_CNY-8b.svg": [
		9038,
		87
	],
	"./holidays/i_CNY-9.svg": [
		98565,
		87
	],
	"./holidays/i_Xmas-10a.svg": [
		46019,
		87
	],
	"./holidays/i_Xmas-10b.svg": [
		79920,
		87
	],
	"./holidays/i_Xmas-11.svg": [
		2687,
		87
	],
	"./holidays/i_Xmas-12.svg": [
		40012,
		87
	],
	"./holidays/i_Xmas-13a.svg": [
		36662,
		87
	],
	"./holidays/i_Xmas-13b.svg": [
		8533,
		87
	],
	"./holidays/i_Xmas-14a.svg": [
		29823,
		87
	],
	"./holidays/i_Xmas-14b.svg": [
		50796,
		87
	],
	"./holidays/i_Xmas-15a.svg": [
		61864,
		87
	],
	"./holidays/i_Xmas-15b.svg": [
		77403,
		87
	],
	"./holidays/i_Xmas-1a.svg": [
		22895,
		87
	],
	"./holidays/i_Xmas-1b.svg": [
		20572,
		87
	],
	"./holidays/i_Xmas-2a.svg": [
		15042,
		87
	],
	"./holidays/i_Xmas-2b.svg": [
		72145,
		87
	],
	"./holidays/i_Xmas-3a.svg": [
		75553,
		87
	],
	"./holidays/i_Xmas-3b.svg": [
		70514,
		87
	],
	"./holidays/i_Xmas-4a.svg": [
		40508,
		87
	],
	"./holidays/i_Xmas-4b.svg": [
		19535,
		87
	],
	"./holidays/i_Xmas-5a.svg": [
		25907,
		87
	],
	"./holidays/i_Xmas-5b.svg": [
		55008,
		87
	],
	"./holidays/i_Xmas-6a.svg": [
		48422,
		87
	],
	"./holidays/i_Xmas-6b.svg": [
		84645,
		87
	],
	"./holidays/i_Xmas-7a.svg": [
		53941,
		87
	],
	"./holidays/i_Xmas-7b.svg": [
		65718,
		87
	],
	"./holidays/i_Xmas-8a.svg": [
		32416,
		87
	],
	"./holidays/i_Xmas-8b.svg": [
		39507,
		87
	],
	"./holidays/i_Xmas-9a.svg": [
		93975,
		87
	],
	"./holidays/i_Xmas-9b.svg": [
		50852,
		87
	],
	"./holidays/i_celebration-10.svg": [
		45131,
		87
	],
	"./holidays/i_celebration-11.svg": [
		39866,
		87
	],
	"./holidays/i_celebration-12a.svg": [
		44314,
		87
	],
	"./holidays/i_celebration-12b.svg": [
		89129,
		87
	],
	"./holidays/i_celebration-13a.svg": [
		43097,
		87
	],
	"./holidays/i_celebration-13b.svg": [
		98698,
		87
	],
	"./holidays/i_celebration-14a.svg": [
		73812,
		87
	],
	"./holidays/i_celebration-14b.svg": [
		45319,
		87
	],
	"./holidays/i_celebration-15.svg": [
		38566,
		87
	],
	"./holidays/i_celebration-16.svg": [
		74789,
		87
	],
	"./holidays/i_celebration-17.svg": [
		96772,
		87
	],
	"./holidays/i_celebration-18.svg": [
		70547,
		87
	],
	"./holidays/i_celebration-19a.svg": [
		99999,
		87
	],
	"./holidays/i_celebration-19b.svg": [
		20972,
		87
	],
	"./holidays/i_celebration-1a.svg": [
		44138,
		87
	],
	"./holidays/i_celebration-1b.svg": [
		93433,
		87
	],
	"./holidays/i_celebration-20a.svg": [
		91195,
		87
	],
	"./holidays/i_celebration-20b.svg": [
		56808,
		87
	],
	"./holidays/i_celebration-2a.svg": [
		93783,
		87
	],
	"./holidays/i_celebration-2b.svg": [
		50660,
		87
	],
	"./holidays/i_celebration-3a.svg": [
		32224,
		87
	],
	"./holidays/i_celebration-3b.svg": [
		39315,
		87
	],
	"./holidays/i_celebration-4a.svg": [
		66109,
		87
	],
	"./holidays/i_celebration-4b.svg": [
		54014,
		87
	],
	"./holidays/i_celebration-5a.svg": [
		82606,
		87
	],
	"./holidays/i_celebration-5b.svg": [
		11725,
		87
	],
	"./holidays/i_celebration-6.svg": [
		18902,
		87
	],
	"./holidays/i_celebration-7.svg": [
		82727,
		87
	],
	"./holidays/i_celebration-8a.svg": [
		75361,
		87
	],
	"./holidays/i_celebration-8b.svg": [
		70322,
		87
	],
	"./holidays/i_celebration-9a.svg": [
		14850,
		87
	],
	"./holidays/i_celebration-9b.svg": [
		55601,
		87
	],
	"./holidays/i_easter-1a.svg": [
		29430,
		87
	],
	"./holidays/i_easter-1b.svg": [
		66069,
		87
	],
	"./holidays/i_easter-2a.svg": [
		49859,
		87
	],
	"./holidays/i_easter-2b.svg": [
		92816,
		87
	],
	"./holidays/i_halloween-10a.svg": [
		689,
		87
	],
	"./holidays/i_halloween-10b.svg": [
		80322,
		87
	],
	"./holidays/i_halloween-11a.svg": [
		96754,
		87
	],
	"./holidays/i_halloween-11b.svg": [
		6241,
		87
	],
	"./holidays/i_halloween-12a.svg": [
		32319,
		87
	],
	"./holidays/i_halloween-12b.svg": [
		53292,
		87
	],
	"./holidays/i_halloween-13a.svg": [
		29160,
		87
	],
	"./holidays/i_halloween-13b.svg": [
		10523,
		87
	],
	"./holidays/i_halloween-1a.svg": [
		1921,
		87
	],
	"./holidays/i_halloween-1b.svg": [
		20178,
		87
	],
	"./holidays/i_halloween-2a.svg": [
		17144,
		87
	],
	"./holidays/i_halloween-2b.svg": [
		75211,
		87
	],
	"./holidays/i_halloween-3a.svg": [
		81327,
		87
	],
	"./holidays/i_halloween-3b.svg": [
		18652,
		87
	],
	"./holidays/i_halloween-4a.svg": [
		57734,
		87
	],
	"./holidays/i_halloween-4b.svg": [
		80165,
		87
	],
	"./holidays/i_halloween-5a.svg": [
		35221,
		87
	],
	"./holidays/i_halloween-5b.svg": [
		14934,
		87
	],
	"./holidays/i_halloween-6a.svg": [
		15900,
		87
	],
	"./holidays/i_halloween-6b.svg": [
		94927,
		87
	],
	"./holidays/i_halloween-7a.svg": [
		1299,
		87
	],
	"./holidays/i_halloween-7b.svg": [
		10560,
		87
	],
	"./holidays/i_halloween-8.svg": [
		14969,
		87
	],
	"./holidays/i_halloween-9.svg": [
		2600,
		87
	],
	"./holidays/i_valentines-1a.svg": [
		26475,
		87
	],
	"./holidays/i_valentines-1b.svg": [
		87640,
		87
	],
	"./holidays/i_valentines-2a.svg": [
		51070,
		87
	],
	"./holidays/i_valentines-2b.svg": [
		88893,
		87
	],
	"./holidays/i_valentines-3a.svg": [
		8749,
		87
	],
	"./holidays/i_valentines-3b.svg": [
		60398,
		87
	],
	"./holidays/i_valentines-4a.svg": [
		84240,
		87
	],
	"./holidays/i_valentines-4b.svg": [
		73635,
		87
	],
	"./holidays/i_valentines-5a.svg": [
		58951,
		87
	],
	"./holidays/i_valentines-5b.svg": [
		87444,
		87
	],
	"./holidays/i_valentines-6a.svg": [
		59194,
		87
	],
	"./holidays/i_valentines-6b.svg": [
		74281,
		87
	],
	"./holidays/i_valentines-7a.svg": [
		62425,
		87
	],
	"./holidays/i_valentines-7b.svg": [
		36426,
		87
	],
	"./holidays/i_valentines-8a.svg": [
		21164,
		87
	],
	"./holidays/i_valentines-8b.svg": [
		191,
		87
	],
	"./nature/i_elements-1.svg": [
		35630,
		87
	],
	"./nature/i_elements-2.svg": [
		18605,
		87
	],
	"./nature/i_elements-3.svg": [
		71244,
		87
	],
	"./nature/i_elements-4.svg": [
		93811,
		87
	],
	"./nature/i_elements-5.svg": [
		90082,
		87
	],
	"./nature/i_elements-6.svg": [
		47185,
		87
	],
	"./nature/i_elements-7.svg": [
		32800,
		87
	],
	"./nature/i_elements-8.svg": [
		84983,
		87
	],
	"./nature/i_environment-1.svg": [
		4400,
		87
	],
	"./nature/i_environment-10.svg": [
		66112,
		87
	],
	"./nature/i_environment-11.svg": [
		28913,
		87
	],
	"./nature/i_environment-12.svg": [
		58018,
		87
	],
	"./nature/i_environment-13.svg": [
		37011,
		87
	],
	"./nature/i_environment-14.svg": [
		52972,
		87
	],
	"./nature/i_environment-15.svg": [
		32685,
		87
	],
	"./nature/i_environment-16.svg": [
		3566,
		87
	],
	"./nature/i_environment-17.svg": [
		24671,
		87
	],
	"./nature/i_environment-18.svg": [
		21784,
		87
	],
	"./nature/i_environment-19.svg": [
		56649,
		87
	],
	"./nature/i_environment-2.svg": [
		65891,
		87
	],
	"./nature/i_environment-3.svg": [
		27954,
		87
	],
	"./nature/i_environment-4.svg": [
		61885,
		87
	],
	"./nature/i_environment-5.svg": [
		91260,
		87
	],
	"./nature/i_environment-6.svg": [
		70287,
		87
	],
	"./nature/i_environment-7.svg": [
		7710,
		87
	],
	"./nature/i_environment-8.svg": [
		85433,
		87
	],
	"./nature/i_environment-9.svg": [
		61160,
		87
	],
	"./nature/i_plants-1.svg": [
		82119,
		87
	],
	"./nature/i_plants-10.svg": [
		7445,
		87
	],
	"./nature/i_plants-11.svg": [
		62516,
		87
	],
	"./nature/i_plants-12.svg": [
		34023,
		87
	],
	"./nature/i_plants-13.svg": [
		94486,
		87
	],
	"./nature/i_plants-14.svg": [
		78169,
		87
	],
	"./nature/i_plants-15.svg": [
		96424,
		87
	],
	"./nature/i_plants-16.svg": [
		77787,
		87
	],
	"./nature/i_plants-17.svg": [
		52170,
		87
	],
	"./nature/i_plants-18.svg": [
		20445,
		87
	],
	"./nature/i_plants-19.svg": [
		91900,
		87
	],
	"./nature/i_plants-2.svg": [
		33908,
		87
	],
	"./nature/i_plants-20.svg": [
		45516,
		87
	],
	"./nature/i_plants-21.svg": [
		76525,
		87
	],
	"./nature/i_plants-22.svg": [
		93550,
		87
	],
	"./nature/i_plants-23.svg": [
		8191,
		87
	],
	"./nature/i_plants-24.svg": [
		7072,
		87
	],
	"./nature/i_plants-25.svg": [
		5105,
		87
	],
	"./nature/i_plants-26.svg": [
		64354,
		87
	],
	"./nature/i_plants-27.svg": [
		51731,
		87
	],
	"./nature/i_plants-28.svg": [
		88452,
		87
	],
	"./nature/i_plants-29.svg": [
		85701,
		87
	],
	"./nature/i_plants-3.svg": [
		6517,
		87
	],
	"./nature/i_plants-4.svg": [
		83306,
		87
	],
	"./nature/i_plants-5.svg": [
		43675,
		87
	],
	"./nature/i_plants-6.svg": [
		9288,
		87
	],
	"./nature/i_plants-7.svg": [
		74681,
		87
	],
	"./nature/i_plants-8.svg": [
		32158,
		87
	],
	"./nature/i_plants-9.svg": [
		59535,
		87
	],
	"./nature/i_weather-1.svg": [
		56055,
		87
	],
	"./nature/i_weather-10.svg": [
		89157,
		87
	],
	"./nature/i_weather-11.svg": [
		11140,
		87
	],
	"./nature/i_weather-12.svg": [
		15735,
		87
	],
	"./nature/i_weather-13.svg": [
		52934,
		87
	],
	"./nature/i_weather-14.svg": [
		96169,
		87
	],
	"./nature/i_weather-2.svg": [
		12932,
		87
	],
	"./nature/i_weather-3.svg": [
		67653,
		87
	],
	"./nature/i_weather-4.svg": [
		56026,
		87
	],
	"./nature/i_weather-5.svg": [
		75083,
		87
	],
	"./nature/i_weather-6.svg": [
		36248,
		87
	],
	"./nature/i_weather-7.svg": [
		71113,
		87
	],
	"./nature/i_weather-8.svg": [
		18030,
		87
	],
	"./nature/i_weather-9.svg": [
		39135,
		87
	],
	"./zodiac/icon-aquarius.svg": [
		75679,
		87
	],
	"./zodiac/icon-aries.svg": [
		36158,
		87
	],
	"./zodiac/icon-cancer.svg": [
		74156,
		87
	],
	"./zodiac/icon-capricorn.svg": [
		47013,
		87
	],
	"./zodiac/icon-gemini.svg": [
		52281,
		87
	],
	"./zodiac/icon-leo.svg": [
		19728,
		87
	],
	"./zodiac/icon-libra.svg": [
		88842,
		87
	],
	"./zodiac/icon-pisces.svg": [
		45515,
		87
	],
	"./zodiac/icon-sagittarius.svg": [
		49946,
		87
	],
	"./zodiac/icon-scorpio.svg": [
		98795,
		87
	],
	"./zodiac/icon-taurus.svg": [
		32748,
		87
	],
	"./zodiac/icon-virgo.svg": [
		89561,
		87
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47338;
module.exports = webpackAsyncContext;